// Blocks keys that a `type="number"` input would otherwise accept but that
// break a "straight integer" value: decimal separators (dot, comma) and
const BLOCKED_KEYS = ['.', ',', 'e', 'E', '+', '-'];

export const preventNonIntegerKeys = (event) => {
  if (BLOCKED_KEYS.includes(event.key)) {
    event.preventDefault();
  }
};

export default preventNonIntegerKeys;
